import moment from "moment";
import api from "./Api";
import { handleApiError } from "../utils/apiUtils";

const DashBoard = process.env.REACT_APP_DASHBOARD_URL || "";
const BillingDashboardAPI = api(DashBoard);

export interface ApiResponse<T> {
  result: T;
  isSuccess: boolean;
  message: string;
  statusCode: number;
}

export const getBillingDashboardTeamList = async () => {
  try {
    const { data } = await BillingDashboardAPI.get(
      "/api/billing-specialist/dashboard/team-client-by-useraccess",
    );

    const result = data?.result ?? [];

    const uniqueData = Array.from(
      new Map(result.map((item: any) => [item.teamId, item])).values(),
    );

    const filterData = uniqueData.map((item: any) => ({
      value: item.teamId,
      label: item.teamName,
    }));

    return filterData;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const getBillingDashboardClientList = async () => {
  try {
    const { data } = await BillingDashboardAPI.get(
      "/api/billing-specialist/dashboard/team-client-by-useraccess",
    );
    const result = data?.result ?? [];
    const filterData = result?.map((item: any) => ({
      value: item.clientId,
      label: item.clientName,
    }));
    return filterData;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const fetchLineItemStatusPipelineData = async (params: any) => {
  try {
    const response = await BillingDashboardAPI.post(
      "/api/billing-specialist/dashboard/status-pipeline",
      params,
    );
    return response.data ?? [];
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const fetchInvoiceReportsData = async (params: any) => {
  try {
    const response = await BillingDashboardAPI.post(
      "/api/billing-specialist/dashboard/invoice-reports",
      params,
    );
    return response.data ?? [];
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const fetchInvoiceTrendsData = async (params: any) => {
  try {
    const response = await BillingDashboardAPI.post(
      "/api/billing-specialist/dashboard/invoice-trend",
      params,
    );
    return response.data ?? [];
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const fetchInvoiceDistributionByRoleData = async (params: any) => {
  try {
    const response = await BillingDashboardAPI.post(
      "/api/billing-specialist/dashboard/invoice-dis-by-role",
      params,
    );
    return response.data ?? [];
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const fetchInvoiceLeaderDashboard = async (
  params: any,
): Promise<any> => {
  try {
    const response = await BillingDashboardAPI.post<ApiResponse<any>>(
      "/api/billing-specialist/dashboard/invoice-leaders-board",
      params,
    );
    const updatedResult = response.data?.result.map((data: any) => ({
      ...data,
      total_Amount:
        data.currency == "INR"
          ? `₹ ${data.total_Amount}`
          : `$ ${data.total_Amount}`,
    }));
    return updatedResult;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const fetchInvoiceActionData = async (params: any) => {
  try {
    const response = await BillingDashboardAPI.post(
      "/api/billing-specialist/dashboard/action-required",
      params,
    );
    return response.data ?? [];
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
